<template>
    <div>
        <script type="application/ld+json" v-html="this.stationDetails.jsonLd"></script>
        <div class="ts-finder__details-map" ref="detailsmap"></div>
        <div class="ts-finder__details-content">
            <div class="contentblock">
                <div class="contentblock__content ts-finder__details-content-inner">
                    <!--directions-->
                    <div class="ts-finder__details-directions">
                        <a class="ts-finder__details-directions-link" :href="directionsUrl" target="_blank" v-if="directionsUrl" :title="strings['TsFinder.Map.Routeplanner']"><i class="fas fa-directions"></i></a><br />
                        {{distance | formatDistance}}
                    </div>
                    <!--back-link-->
                    <router-link to="/" class="ts-finder__details-back"><i class="fas fa-times"></i></router-link>
                    <!--header-->
                    <div class="ts-finder__details-header">
                        <div class="ts-finder__details-columns ts-finder__details-columns--middle">
                            <div class="ts-finder__details-left" style="display:flex">
                                <div class="ts-finder__details-logo"><img :src="this.stationDetails.brandurl" /></div>
                                <div class="ts-finder__details-address">
                                    <div class="ts-finder__details-station-name">{{this.stationDetails.name}}</div>
                                    <div class="ts-finder__details-station-address">
                                        <div v-if="this.stationDetails.street" v-html="this.stationDetails.street"></div>
                                        <div v-if="this.stationDetails.zipcity" v-html="this.stationDetails.zipcity"></div>
                                    </div>
                                    <div class="ts-finder__details-station-phone" v-if="this.stationDetails.phone">{{strings['TsFinder.Filter.PhoneNumber']}} <a :href="'tel:' + this.stationDetails.phone_int">{{this.stationDetails.phone}}</a></div>
                                </div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-services">
                                    {{strings['TsFinder.Map.Services']}}
                                    <ul class="ts-finder__details-services-list">
                                        <li class="ts-finder__icon ts-finder__icons-tankstelle" v-if="this.stationDetails.tankstelle" :title="strings['TsFinder.Filter.Tankstelle']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-fastcharging" v-if="this.stationDetails.fastcharging" :title="strings['TsFinder.Filter.FastCharging']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-wasserstoff" v-if="this.stationDetails.wasserstoff" :title="strings['TsFinder.Filter.Wasserstoff']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-shop" v-if="this.stationDetails.shop && this.stationDetails.shop.shoptype === 'migrol'" :title="strings['TsFinder.Filter.Shop']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-migrolino" v-if="this.stationDetails.shop && this.stationDetails.shop.shoptype === 'migrolino'" :title="strings['TsFinder.Filter.ShopMigrolino']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-mio" v-if="this.stationDetails.shop && this.stationDetails.shop.shoptype === 'miobymigrolino'" :title="strings['TsFinder.Filter.ShopMio']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-carwash" v-if="this.stationDetails.carwash" :title="strings['TsFinder.Filter.CarWash']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-autoservice" v-if="this.stationDetails.autoservice" :title="strings['TsFinder.Filter.AutoService']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-migrolcard" :title="strings['TsFinder.Filter.IsMigrolStandort']"></li>
                                        <li class="ts-finder__icon ts-finder__icons-hasWC" title="WC" v-if="this.stationDetails.hasWC"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--tankstelle-->
                    <div v-if="this.stationDetails.tankstelle" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <div class="ts-finder__details-left">
                                <div v-if="this.stationDetails.tankstelle.hours" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.StationHours']}}:</strong>
                                    <div v-if="this.stationDetails.tankstelle.hours" v-html="this.stationDetails.tankstelle.hours"></div>
                                </div>
                                <div class="ts-finder__details-migrol-shell-info" v-if="this.stationDetails.migrol_shell">{{strings['TsFinder.Map.MigrolShellInfo']}}</div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-promo ts-finder__details--desktop-only" v-if="this.stationDetails.tankstelle.promotion">
                                    <a :href="this.stationDetails.tankstelle.promotion.pageUrl">
                                        <img :src="this.stationDetails.tankstelle.promotion.bannerUrl" />
                                        {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="ts-finder__details-full-width">
                            <div class="ts-finder__details-capabilities ts-finder__details-capabilities--columns">
                                <div class="ts-finder__details-capabilities-left">
                                    <ul class="ts-finder__details-capabilities ts-finder__details-capabilities--fixed-height">
                                        <li v-if="this.stationDetails.tankstelle.hasBleifrei95">{{strings['TsFinder.Filter.Bleifrei95']}}</li>
                                        <li v-if="this.stationDetails.tankstelle.hasBleifrei98">{{strings['TsFinder.Filter.Bleifrei98']}}</li>
                                        <li v-if="this.stationDetails.tankstelle.hasDiesel">{{strings['TsFinder.Filter.Diesel']}}</li>
                                        <li v-if="this.stationDetails.tankstelle.hasVPower100">{{strings['TsFinder.Filter.VPower100']}}</li>
                                        <li v-if="this.stationDetails.tankstelle.hasVPowerDiesel">{{strings['TsFinder.Filter.VPowerDiesel']}}</li>
                                    </ul>
                                </div>
                                <div class="ts-finder__details-capabilities-right">
                                    <ul class="ts-finder__details-capabilities-with-icons ts-finder__details-capabilities-with-icons--cols">
                                        <li v-if="this.stationDetails.tankstelle.hasAdBlueCan">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-adblue-can"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.AdBlueCan']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasAdBluePumpPW && !this.stationDetails.tankstelle.hasAdBluePumpLKW">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-adblue-pump"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.AdBluePumpPW']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="!this.stationDetails.tankstelle.hasAdBluePumpPW && this.stationDetails.tankstelle.hasAdBluePumpLKW">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-adblue-pump"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.AdBluePumpLKW']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasAdBluePumpPW && this.stationDetails.tankstelle.hasAdBluePumpLKW">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-adblue-pump"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.AdBluePumpPWLKW']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasLkw70">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-lkw"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.LKWTauglich70']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasLkw130">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-lkw"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.LKWTauglich130']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasErdgas">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-erdgas"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.Erdgas']}}</div>
                                            </div>
                                        </li>

                                        <li v-if="this.stationDetails.tankstelle.hasLPGGPL">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-lpggpl"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.LPGGPL']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.tankstelle.hasWasserstoff">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-wasserstoff"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.Wasserstoff']}}</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.fillingstations" v-html="this.stationDetails.moreinfolinks.fillingstations"></div>
                        </div>
                        <div class="ts-finder__details-full-width ts-finder__details--mobile-only">
                            <div class="ts-finder__details-promo" v-if="this.stationDetails.tankstelle.promotion">
                                <a :href="this.stationDetails.tankstelle.promotion.pageUrl">
                                    <img :src="this.stationDetails.tankstelle.promotion.bannerUrl" />
                                    {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--fast charging-->
                    <div v-if="this.stationDetails.fastcharging" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <!--fast charging-->
                            <div v-if="this.stationDetails.fastcharging" class="ts-finder__details-left">
                                <div class="ts-finder__details-mcharge-title">
                                    <img :src="this.mchargeLogoUrl" alt="M-Charge" />
                                </div>
                                <div class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} M-Charge:</strong>

                                    <div v-if="this.stationDetails.fastcharging.hours" v-html="this.stationDetails.fastcharging.hours"></div>
                                    <div v-else>
                                        <div v-if="this.stationDetails.fastchargingopeninghourslikeshop">{{strings['TsFinder.Map.HoursFastChargingLikeShop']}}</div>
                                        <div v-else>{{strings['TsFinder.Map.HoursFastCharging']}}</div>
                                    </div>
                                </div>

                                <div class="ts-finder__details-capabilities ts-finder__details-capabilities--columns">
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.numMCharge > 0">
                                        <strong>M-Charge</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-ACTyp2"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">AC Typ II</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.numClassic > 0">
                                        <strong>M-Charge 128 kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CHAdeMO"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CHAdeMO</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.numClassicCcsOnly > 0">
                                        <strong>M-Charge 128 kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.numPremium > 0">
                                        <strong>M-Charge 320 kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- M-Charge -->
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.hasMChargeC">
                                        <strong>M-Charge 50 - 60kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.hasMChargeB">
                                        <strong>M-Charge 50 - 60kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CCS"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CCS</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-CHAdeMO"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">CHAdeMO</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ts-finder__details-capabilities-column" v-if="this.stationDetails.fastcharging.hasMChargeA">
                                        <strong>M-Charge 22 kW</strong>
                                        <ul class="ts-finder__details-capabilities-with-icons">
                                            <li>
                                                <div class="ts-finder__details-capability-icon-row">
                                                    <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-fastcharging-ACTyp2"></div>
                                                    <div class="ts-finder__details-capability-icon-legend">Typ 2</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.fastcharging && !this.stationDetails.m_charge" v-html="this.stationDetails.moreinfolinks.fastcharging"></div>
                                <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.mcharge && this.stationDetails.m_charge" v-html="this.stationDetails.moreinfolinks.mcharge"></div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-promo" v-if="this.stationDetails.fastcharging.promotion">
                                    <a :href="this.stationDetails.fastcharging.promotion.pageUrl">
                                        <img :src="this.stationDetails.fastcharging.promotion.bannerUrl" />
                                        {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--wasserstoff-->
                    <div v-if="this.stationDetails.wasserstoff" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <div class="ts-finder__details-left">
                                <div class="ts-finder__details-servicetitle">
                                    {{strings['TsFinder.Filter.Wasserstoff']}}
                                </div>
                                <div class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}}:</strong>
                                    {{strings['TsFinder.Map.HoursWasserstoff']}}
                                </div>
                                <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.wasserstoff" v-html="this.stationDetails.moreinfolinks.wasserstoff"></div>
                            </div>
                            <div class="ts-finder__details-right">
                            </div>
                        </div>
                    </div>

                    <!--car wash-->
                    <div v-if="this.stationDetails.carwash" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <div class="ts-finder__details-left">
                                <div class="ts-finder__details-servicetitle">
                                    <img :src="this.carwashLogoUrl" alt="Migrol Car Wash" />
                                </div>
                                <div v-if="this.stationDetails.carwash.hours1" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} {{this.stationDetails.carwash.hours1ServiceTitle}}:</strong>
                                    <div v-html="this.stationDetails.carwash.hours1"></div>
                                </div>
                                <div v-if="this.stationDetails.carwash.hours2" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} {{this.stationDetails.carwash.hours2ServiceTitle}}:</strong>
                                    <div v-html="this.stationDetails.carwash.hours2"></div>
                                </div>
                                <div class="ts-finder__details-capabilities">
                                    <ul class="ts-finder__details-capabilities-with-icons">
                                        <li v-if="this.stationDetails.carwash.hasCarWashPlus">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-plus"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.CarWashPlus']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.carwash.hasWaschstrasseBedient">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-waschstrasse"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.WaschstrasseBedient']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.carwash.hasWaschanlage">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-waschanlage"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.Waschanlage']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.carwash.hasSelbstbedienungWaschboxen">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-sb"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.SelbstbedienungWaschboxen']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.carwash.hasSelbstbedienungStaubsauger">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-sb-sauger"></div>
                                                <div class="ts-finder__details-capability-icon-legend">{{strings['TsFinder.Filter.SelbstbedienungStaubsauger']}}</div>
                                            </div>
                                        </li>
                                        <li v-if="this.stationDetails.carwash.hasInnenreinigung">
                                            <div class="ts-finder__details-capability-icon-row">
                                                <div class="ts-finder__details-capability-icon ts-finder__details-capability-icon-carwash-innenreinigung"></div>
                                                <div class="ts-finder__details-capability-icon-legend">
                                                    <a class="ts-finder__details-more-infos-link" :href="this.stationDetails.carwash.innenreinigungUrl" v-if="this.stationDetails.carwash.innenreinigungUrl" target="_blank">{{strings['TsFinder.Map.InnenreinigungLink']}} <i class="fas fa-angle-right"></i></a>
                                                    <span v-if="!this.stationDetails.carwash.innenreinigungUrl">{{strings['TsFinder.Filter.Innenreinigung']}}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="this.stationDetails.carwash.hasDeviantPaymentMethods" class="ts-finder__details-warning">
                                    {{strings['TsFinder.Map.DeviantPaymentMethods']}}
                                </div>
                                <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.carwash" v-html="this.stationDetails.moreinfolinks.carwash"></div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-promo" v-if="this.stationDetails.carwash.promotion">
                                    <a :href="this.stationDetails.carwash.promotion.pageUrl">
                                        <img :src="this.stationDetails.carwash.promotion.bannerUrl" />
                                        {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--shop and Vapiano-->
                    <div v-if="this.stationDetails.shop || this.stationDetails.vapiano" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <!--Shop-->
                            <div v-if="this.stationDetails.shop" class="ts-finder__details-left ts-finder__details-left--tablet-same-size">
                                <div class="ts-finder__details-servicetitle">
                                    <img :src="this.migrolinoLogoUrl" alt="migrolino Logo" v-if="this.stationDetails.shop.shoptype === 'migrolino'" height="61" />
                                    <img :src="this.mioLogoUrl" alt="mio by migrolino Logo" v-if="this.stationDetails.shop.shoptype === 'miobymigrolino'" height="120" />
                                    <span v-if="this.stationDetails.shop.shoptype === 'migrol'">Shop</span>
                                </div>
                                <div v-if="this.stationDetails.shop.hours" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} Shop:</strong>
                                    <div v-html="this.stationDetails.shop.hours"></div>
                                </div>
                            </div>

                            <!--Vapiano-->
                            <div v-if="this.stationDetails.vapiano" class="ts-finder__details-right">
                                <div class="ts-finder__details-servicetitle">
                                    <img :src="this.vapianoLogoUrl" alt="Vapiano Logo" height="61" />
                                </div>
                                <div v-if="this.stationDetails.vapiano.hours" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} Vapiano:</strong>
                                    <div v-html="this.stationDetails.vapiano.hours"></div>
                                </div>
                            </div>

                        </div>
                        <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.shop" v-html="this.stationDetails.moreinfolinks.shop"></div>
                    </div>

                    <!--auto service-->
                    <div v-if="this.stationDetails.autoservice" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <div class="ts-finder__details-left">
                                <div class="ts-finder__details-servicetitle">
                                    <img :src="this.autoserviceLogoUrl" alt="Migrol Auto Service Logo" />
                                </div>
                                <div v-if="this.stationDetails.autoservice.hours" class="ts-finder__details-hours">
                                    <strong>{{strings['TsFinder.Map.Hours']}} Auto Service</strong>
                                    <div v-html="this.stationDetails.autoservice.hours"></div>
                                </div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-promo" v-if="this.stationDetails.autoservice.promotion">
                                    <a :href="this.stationDetails.autoservice.promotion.pageUrl">
                                        <img :src="this.stationDetails.autoservice.promotion.bannerUrl" />
                                        {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="ts-finder__details-full-width">
                            <div class="migrol-rt-content ts-finder__details-autoservice-rte" v-show="this.stationDetails.autoservice.description" v-html="this.stationDetails.autoservice.description"></div>
                            <div class="ts-finder__details-more-infos" v-if="pneuOfferUrl"><a class="ts-finder__details-more-infos-link" :href="pneuOfferUrl" :title="strings['TsFinder.Map.PneuOfferLink']">{{strings['TsFinder.Map.PneuOfferLink']}} <i class="fas fa-angle-right"></i></a></div>
                            <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.autoservice" v-html="this.stationDetails.moreinfolinks.autoservice"></div>
                        </div>
                    </div>
                    <!--migrolcard-->
                    <div v-if="this.stationDetails.migrolcard" class="ts-finder__details-service">
                        <div class="ts-finder__details-columns">
                            <div class="ts-finder__details-left">
                                <div class="ts-finder__details-servicetitle">
                                    Migrolcard
                                </div>
                                <div class="ts-finder__details-migrolcard-info" v-show="this.stationDetails.migrolcardinfo.text">
                                    <div class="ts-finder__details-migrolcard-info-image" v-if="this.stationDetails.migrolcardinfo.image"><img :src="this.stationDetails.migrolcardinfo.image" /></div>
                                    <div class="ts-finder__details-migrolcard-info-text migrol-rt-content" v-html="this.stationDetails.migrolcardinfo.text"></div>
                                </div>
                                <div class="ts-finder__details-more-infos" v-if="this.stationDetails.moreinfolinks.migrolcard" v-html="this.stationDetails.moreinfolinks.migrolcard"></div>
                            </div>
                            <div class="ts-finder__details-right">
                                <div class="ts-finder__details-promo" v-if="this.stationDetails.migrolcard.promotion">
                                    <a :href="this.stationDetails.migrolcard.promotion.pageUrl">
                                        <img :src="this.stationDetails.migrolcard.promotion.bannerUrl" />
                                        {{strings['TsFinder.Map.PromoInfoLink']}} <i class="fas fa-angle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ts-finder__details-service" v-if="showPaymentMethods">
                        <div class="ts-finder__details-full-width">
                            <div class="ts-finder__details-servicetitle">
                                {{strings['TsFinder.Map.PaymentMethods']}}
                            </div>
                            <ul class="ts-finder__details-paymentmethods">
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-migrolcard"></div><div class="ts-finder__details-payment-icon-legend">Migrolcard</div></div></li>
                                <li v-if="(this.stationDetails.paymentnational && this.stationDetails.tankstelle) || this.hasMchargeBasic"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-migrolcard-app"></div><div class="ts-finder__details-payment-icon-legend">Migrolcard App</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-migrol-geschenkkarte"></div><div class="ts-finder__details-payment-icon-legend" v-html="strings['TsFinder.Map.Giftcard']"></div></div></li>
                                <li v-if="this.stationDetails.paymentcarwashcard"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-migrol-carwashcard"></div><div class="ts-finder__details-payment-icon-legend">Migrol Car Wash Card</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-m-card"></div><div class="ts-finder__details-payment-icon-legend">M-Card</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-maestro"></div><div class="ts-finder__details-payment-icon-legend">Maestro</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-postfinance"></div><div class="ts-finder__details-payment-icon-legend">PostFinance Card</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-mastercard"></div><div class="ts-finder__details-payment-icon-legend">Mastercard</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-visa"></div><div class="ts-finder__details-payment-icon-legend">VISA</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-amex"></div><div class="ts-finder__details-payment-icon-legend">American Express</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-diners"></div><div class="ts-finder__details-payment-icon-legend">Diners</div></div></li>
                                <li v-if="this.stationDetails.paymentnational"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-v-pay"></div><div class="ts-finder__details-payment-icon-legend">V PAY</div></div></li>
                                <li v-if="this.stationDetails.paymenteuroshell"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-euroshell"></div><div class="ts-finder__details-payment-icon-legend">Shell Card</div></div></li>
                                <li v-if="this.stationDetails.paymenttwint"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-twint"></div><div class="ts-finder__details-payment-icon-legend">Twint</div></div></li>
                                <li v-if="(this.stationDetails.paymentnational && this.stationDetails.tankstelle) || this.hasMchargeBasic"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-autosense"></div><div class="ts-finder__details-payment-icon-legend">autoSense App</div></div></li>
                                <li v-if="this.stationDetails.paymentbargeldbezug"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-cash"></div><div class="ts-finder__details-payment-icon-legend" v-html="strings['TsFinder.Map.Bargeldbezug']"></div></div></li>
                                <li v-if="this.stationDetails.paymentatm"><div class="ts-finder__details-payment-icon-row"><div class="ts-finder__details-payment-icon ts-finder__details-payment-icon-atm"></div><div class="ts-finder__details-payment-icon-legend" v-html="strings['TsFinder.Map.Bankomat']"></div></div></li>
                            </ul>
                        </div>
                    </div>
                    <div class="ts-finder__details-service">
                        <div class="ts-finder__details-cumulus-info">
                            <div class="ts-finder__details-cumulus-info-image"><img :src="this.cumulusCardUrl" alt="Cumulus" /></div>
                            <div class="ts-finder__details-cumulus-info-text">{{strings['TsFinder.Map.CumulusInfo']}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import gmapsInit from '../../utils/gmapsInit';
    import store from '../../store/store'
    import { mapState } from 'vuex'
    import $ from 'jQuery'
    import * as Utils from '../../utils/utils'

    export default {
        data() {
            return {
                google: null,
                map: null,
                marker: null,
                distance: null,
                directionsUrl: null
            };
        },
        computed: {
            ...mapState([
                'stationDetails',
                'userLocation',
                'strings'
            ]),
            migrolinoLogoUrl() {
                return window.TS_CONFIG.logos.migrolino;
            },
            mioLogoUrl() {
                return window.TS_CONFIG.logos.mio;
            },
            vapianoLogoUrl() {
                return window.TS_CONFIG.logos.vapiano;
            },
            cumulusCardUrl() {
                return window.TS_CONFIG.logos.cumulus;
            },
            carwashLogoUrl() {
                return window.TS_CONFIG.logos.carwash;
            },
            autoserviceLogoUrl() {
                return window.TS_CONFIG.logos.autoservice;
            },
            directionsIcon() {
                return window.TS_CONFIG.directions;
            },
            showPaymentMethods() {
                return !this.stationDetails.m_charge
                    && (
                        this.stationDetails.paymentnational
                        || this.stationDetails.paymenttwint
                        || this.stationDetails.paymentcarwashcard
                        || this.stationDetails.paymentatm
                        || this.hasMchargeBasic
                    );
            },
            mchargeLogoUrl() {
                return window.TS_CONFIG.logos.mcharge;
            },
            hasMchargeBasic() {
                return this.stationDetails.m_charge && this.stationDetails.fastcharging && this.stationDetails.fastcharging.hasMChargeA;
            },
            hasMchargeComfort() {
                return this.stationDetails.m_charge && this.stationDetails.fastcharging && (this.stationDetails.fastcharging.hasMChargeB || this.stationDetails.fastcharging.hasMChargeC);
            },
            pneuOfferUrl() {
                if (window.TS_CONFIG.pneuOfferUrl)
                    return `${window.TS_CONFIG.pneuOfferUrl}?stn=${this.stationDetails.id}`;
                else
                    return null;
            }
        },
        watch: {
            stationDetails() {
                //update the map to show the newest station details
                this.updateMapData();
                $('#js-ts-finder__autoservice-description-toggle').show();
                $('#js-ts-finder__autoservice-description').hide();
            }
        },
        methods: {
            initializeMap() {
                //initializes the map at the top. this is only called once and then the map is reused whenever the details view is shown
                const mapConfig = {
                    zoom: 13,
                    center: {
                        //bern
                        lat: 46.947975,
                        lng: 7.447447
                    },
                    mapTypeId: 'roadmap',
                    disableDefaultUI: true,
                    gestureHandling: 'none'
                };

                const { Map, } = this.google.maps;
                const mapContainer = this.$refs.detailsmap;
                this.map = new Map(mapContainer, mapConfig);
            },
            updateMapData() {
                let that = this;

                //this method updates the details view map to the currently selected stationDetails
                if (this.map === null)
                    this.initializeMap();
                if (this.marker !== null)
                    this.marker.setMap(null);

                const { Marker, Point } = this.google.maps;

                //add the marker
                this.marker = new Marker({
                    position: { lat: this.stationDetails.latitude, lng: this.stationDetails.longitude },
                    icon: this.stationDetails.markerselectedurl,
                    map: this.map
                });

                this.marker.addListener('click', () => {
                    //navigate back to "/" on marker click
                    that.$router.push('/').catch(() => { });
                });

                this.map.setCenter({ lat: this.stationDetails.latitude, lng: this.stationDetails.longitude });

                //now offset the map center by -200 pixels vertically (this must be done in 'idle', since getProjection is only available when the map is fully initialized...)
                //this is not done for mobile, since the map is not "behind" the content there
                if (window.innerWidth >= 900) {
                    this.google.maps.event.addListenerOnce(this.map, "idle", function () {
                        let theMap = this;
                        let offsetY = 150;
                        let point1 = theMap.getProjection().fromLatLngToPoint(theMap.getCenter());
                        let point2 = new Point(0, offsetY / Math.pow(2, theMap.getZoom()));
                        theMap.setCenter(theMap.getProjection().fromPointToLatLng(new Point(point1.x - point2.x, point1.y + point2.y)));
                    });
                }

                this.google.maps.event.addListener(this.map, "click", function () {
                    //navigate back to "/" on map click
                    that.$router.push('/').catch(() => { });
                });

                //update the route planner link and the distance if a userLocation is set
                this.directionsUrl = Utils.createDirectionsUrl(this.stationDetails, this.userLocation);
                if (this.stationDetails.latitude && this.stationDetails.longitude && this.userLocation != null) {
                    this.distance = Utils.calculateDistance(this.userLocation.latitude, this.userLocation.longitude, this.stationDetails.latitude, this.stationDetails.longitude);
                } else {
                    this.distance = null;
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            //load the details for the requested station into the store
            store.dispatch('loadDetailsData', to.params.detailsurl)
                .then(() => {
                    //update the breadcrumbs
                    if (store.state.stationDetails != null) {
                        let breadcrumbItem = $('.breadcrumbs__item:last-child').first().clone();
                        let breadcrumbLink = $('a', breadcrumbItem);
                        let itemUrl = window.TS_CONFIG.baseUrl + to.params.detailsurl;
                        let positionItem = $('meta[itemprop=position]', breadcrumbItem);

                        if (breadcrumbLink.attr('href') != itemUrl) {
                            breadcrumbLink.attr('href', itemUrl);
                            var city = store.state.stationDetails.zipcity.replace(/\d{4}&nbsp;/, '');
                            if (store.state.stationDetails.shell_shell)
                                city = ''; //shell-shell stations have the city in the name already
                            $('span[itemprop=name]', breadcrumbItem).html(store.state.stationDetails.name + ' ' + city);
                            positionItem.attr('content', parseInt(positionItem.attr('content')) + 1);
                            $('.breadcrumbs__list').append(breadcrumbItem);
                        }

                        //update canonical link
                        $('link[rel="canonical"]').attr('href', store.state.stationDetails.canonical);

                        //update language switcher
                        $('.meta-nav__subitems .meta-nav__link').each(function (index, item) {
                            var $item = $(item);
                            switch ($item.text()) {
                                case 'DE':
                                case 'FR':
                                case 'IT':
                                    if ($item.attr('href').indexOf(to.params.detailsurl) == -1) {
                                        $item.attr('href', $item.attr('href') + ($item.attr('href').endsWith('/') ? '' : '/') + to.params.detailsurl); //append detailsurl to existing language switcher links (detailsurl comes languageindependent from SAP)
                                    }
                                    break;
                            }
                        });

                    }
                    next();
                });
        },
        beforeRouteLeave(to, from, next) {
            //remove the breadcrumbs entry for the details view
            $('.breadcrumbs__item:last-child').remove();

            //change canonical
            $('link[rel="canonical"]').attr('href', window.TS_CONFIG.baseUrl);

            //update language switcher
            $('.meta-nav__subitems .meta-nav__link').each(function (index, item) {
                var $item = $(item);
                switch ($item.text()) {
                    case 'DE':
                    case 'FR':
                    case 'IT':
                        //remove details url from language switcher
                        if ($item.attr('href').indexOf(from.params.detailsurl) > -1)
                            $item.attr('href', $item.attr('href').substring(0, $item.attr('href').lastIndexOf('/')));
                        break;
                }
            });

            next();
        },
        async mounted() {
            gmapsInit().then(googleObject => {
                this.google = googleObject;
                this.initializeMap();
                this.updateMapData();
            });

            $('#js-ts-finder__autoservice-description-toggle').click(() => {
                $('#js-ts-finder__autoservice-description-toggle').hide();
                $('#js-ts-finder__autoservice-description').slideDown();
            });
        }
    };
</script>